import { useContext } from "react";

import { ProductsContext } from "../contexts/ProductsContext";

const useProductsContext = () => {
  const context = useContext(ProductsContext);

  if (!context) throw new Error("Products context must be use inside Provider");

  return context;
};

export default useProductsContext;
